import { getMentionNodeDisplayText } from '#pplx/frontend/composer-sdk/lexical/nodes/MentionNodeShared.js';
/** @returns Ordered menu groups, starting a new group at each legacy separator. */
export function toMentionTypeaheadGroups({ options, }) {
    return options.reduce((groups, option) => {
        const item = toMentionTypeaheadItem({ option });
        if (groups.length === 0 || option.separatorBefore) {
            return [...groups, { id: `${option.variant}:${option.uuid}`, items: [item] }];
        }
        const previous = groups.at(-1);
        return [...groups.slice(0, -1), { ...previous, items: [...previous.items, item] }];
    }, []);
}
function toMentionTypeaheadItem({ option, }) {
    return {
        id: option.uuid,
        label: getMentionNodeDisplayText({
            text: option.label,
            localizedName: option.localizedName,
            mentionVariant: option.variant,
        }),
        ...(option.subtitle === undefined ? {} : { subtitle: option.subtitle }),
        ...(option.icon === undefined ? {} : { icon: option.icon }),
        ...(option.disabled === undefined ? {} : { disabled: option.disabled }),
        payload: option,
    };
}
//# sourceMappingURL=mentionTypeaheadGroups.js.map